import styled from 'styled-components';
import { designTokens } from '../../ui/foundation/DesignTokens';

// Dropdown container
export const ModalContent = styled.div`
  width: 400px;
  max-width: 90vw;
  max-height: 600px;
  position: fixed;
  top: 4.5rem;
  right: 1.5rem;
  background: white;
  border-radius: ${designTokens.radius.lg};
  box-shadow: ${designTokens.shadows.xl};
  border: 1px solid ${designTokens.colors.gray[200]};
  padding: ${designTokens.spacing.xl};
  display: ${(props) => (props.open ? "flex" : "none")};
  flex-direction: column;
  gap: 16px;
  z-index: 1000;
  overflow-y: auto;

  /* Triangular arrow at top */
  &::before {
    content: '';
    position: absolute;
    top: -6px;
    right: 24px;
    width: 12px;
    height: 12px;
    background: white;
    border-top: 1px solid ${designTokens.colors.gray[200]};
    border-left: 1px solid ${designTokens.colors.gray[200]};
    transform: rotate(45deg);
  }

  @media (max-width: 768px) {
    width: calc(100vw - 32px);
    right: 16px;
    padding: 16px;
  }
`;

// Space card item
export const SpaceCard = styled.div`
  background: white;
  border: 1px solid ${designTokens.colors.gray[200]};
  border-radius: ${designTokens.radius.md};
  padding: 20px;
  display: flex;
  gap: 16px;
  transition: all 0.2s ease;
  cursor: pointer;

  ${props => props.selected && `
    border-color: ${designTokens.colors.primary[500]};
    background: ${designTokens.colors.primary[50]};
  `}

  &:hover {
    border-color: ${designTokens.colors.primary[500]};
    box-shadow: 0 4px 12px rgba(44, 95, 78, 0.08);
    transform: translateY(-1px);
  }
`;

// Space avatar
export const SpaceImg = styled.div`
  width: 48px;
  height: 48px;
  min-width: 48px;
  background-color: ${designTokens.colors.accent[400]};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: ${designTokens.shadows.sm};
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

// Space content container
export const SpaceContent = styled.div`
  flex: 1;
  min-width: 0;
`;

// Space name/title
export const SpaceName = styled.h4`
  font-family: ${designTokens.fonts.heading};
  font-weight: 800;
  font-size: 1rem;
  color: ${designTokens.colors.gray[900]};
  margin: 0 0 6px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// Space meta container (phones with icon)
export const SpaceMeta = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

// WhatsApp icon
export const WaIcon = styled.span`
  color: ${designTokens.colors.whatsapp};
  font-size: ${designTokens.fontSizes.base};
  margin-top: 2px;
  flex-shrink: 0;
`;

// Phone numbers
export const SpacePhones = styled.p`
  font-family: ${designTokens.fonts.heading};
  font-weight: 700;
  font-size: 0.85rem;
  color: ${designTokens.colors.gray[600]};
  line-height: 1.5;
  margin: 0;
  word-break: break-word;
`;

// Menu links section
export const MenuSection = styled.div`
  padding-top: 12px;
  border-top: 1px solid ${designTokens.colors.gray[100]};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: ${designTokens.radius.md};
  border: none;
  background: transparent;
  font-family: ${designTokens.fonts.heading};
  font-weight: 600;
  font-size: 0.9rem;
  color: ${designTokens.colors.gray[700]};
  cursor: pointer;
  transition: all 0.15s ease;
  width: 100%;
  text-align: left;

  &:hover {
    background: ${designTokens.colors.gray[50]};
    color: ${designTokens.colors.gray[900]};
  }

  svg {
    font-size: 1rem;
    color: ${designTokens.colors.gray[500]};
  }

  &:hover svg {
    color: ${designTokens.colors.primary[500]};
  }
`;

// Footer container
export const DropdownFooter = styled.div`
  padding-top: 12px;
  border-top: 1px solid ${designTokens.colors.gray[100]};
  display: flex;
  justify-content: center;
`;

// Logout button
export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${designTokens.spacing.sm};
  padding: 10px ${designTokens.spacing.xl};
  border-radius: ${designTokens.radius.full};
  border: none;
  background: ${designTokens.colors.error[500]};
  font-family: ${designTokens.fonts.heading};
  font-weight: 600;
  font-size: ${designTokens.fontSizes.sm};
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${designTokens.colors.error[600]};
    transform: translateY(-1px);
    box-shadow: ${designTokens.shadows.md};
  }

  svg, i {
    font-size: ${designTokens.fontSizes.sm};
  }
`;
